<template >
  <section id="why">
    <div hidden>DCHHCC, Audi PreOwned DCH, Audi preowned price hk, Audi preowned price, Audi大昌二手, 奧迪大昌二手, 奧迪大昌二手, 奧迪大昌認可</div>
    <div id="banner" class="animate__animated animate__fadeIn">
        <div class="container-fluid">
            <div class="row">
              <picture>
                <source media="(min-width: 768px)" srcset="../picture/whybuyaudiapproved1.jpg">
                <source media="(min-width: 1px)" srcset="../picture/whybuyaudiapproved2.jpg">
                <img src="../picture/whybuyaudiapproved1.jpg" />
              </picture>
                <!-- <img class="hidden-xs" src="../picture/whybuyaudiapproved1.jpg" />
                <img class="visible-xs" src="../picture/whybuyaudiapproved2.jpg" /> -->
            </div>
        </div>
    </div>
    
    <div id="main">
      <div class="container-my">
          <div class="content-wrapper text1">
            <h2 v-html="$t('whybuyaudiapproved.h2')"></h2>
            <p v-html="$t('whybuyaudiapproved.p')"></p>
          </div>
          <div class="blog-wrapper">
            <div class="row ul">
              <div class="col-my-12 col-xs-6 col-sm-4 col-md-4 li" v-for="(item, index) in colList" :key="index">
                <!-- <div :class="['blog', itemInner.off ? 'active' : '']" v-for="(itemInner, indexInner) in item.blogList" :key="indexInner" @click="itemInner.off = !itemInner.off">
                    <div class="blog-title">
                        <a href="javascript:void(0);" class="show-blog">{{itemInner.title}}</a>
                        <img :src="itemInner.iconSrc">
                    </div>
                    <el-collapse-transition>
                      <div id="string" class="blog-content" v-show="itemInner.off">
                        {{itemInner.content}}
                        <div class="more" :hidden="itemInner.more == '' ? true : false"><a href="#content1" class="more">{{itemInner.more}}</a></div>
                      </div>
                    </el-collapse-transition>
                </div> -->
                <div class="box" >
                  <img class="animate__animated animate__fadeIn hidden-xs" :src="item.img" />
                  <img class="animate__animated animate__fadeIn visible-xs" :src="item.imgxs" />
                  <div class="tent">
                    <strong>{{item.title}}</strong>
                    <p v-html="item.text"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  metaInfo: {
    title: 'approvedplus.hk - Why buy an Audi Approved :plus?', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'DCHHCC, Audi PreOwned DCH, Audi preowned price hk, Audi preowned price, Audi大昌二手, 奧迪大昌二手, 奧迪大昌二手, 奧迪大昌認可'
    },
    {
      name: 'description',
      content: 'The only Audi authorized pre-owned centre in Hong Kong, 100% proven quality. Explore the one-stop service now! Enquiry: 22910000. 奧迪認可易手車中心，全港唯一原廠認證，100%品質保證，立即體驗一站式交易服務，查詢請致電22910000。'
    }]
  },
  name: "WhyBuyAudiApproved",
  inject: ['reload'],
  data() {
    return {
      colList: []
    };
  },
  components: {},
  mounted() {
    let that = this
    that.whybuyaudiapproved()

    PubSub.subscribe('locale', (msg, data) => {
			if (data.locale != '') {
      	that.reload()
				that.$validator.locale = that.$store.state.locale
			}
		})
  },
  methods: {
		//替换中英文
		whybuyaudiapproved() {
			let that = this
			that.colList = that.$t('whybuyaudiapproved.col')
		},
    // handleClick(e, val) {
    //   val.off = !val.off
    //   // e.currentTarget.firstElementChild.nextElementSibling.addClass="animated bounceOutLeft"
    //   console.log('target', e.target)
    //   console.log('currentTarget', e.currentTarget.firstElementChild.nextElementSibling)
    //   console.log('currentTarget', e.currentTarget.parentElement)
    // }
  },
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
 /*自己的动画*/
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s
  }

  /*why*/
  #why .blog-wrapper .row>div {    
    padding-right: 0;
    padding-left: 0;
  }

  #why .blog-wrapper {
    width: 100%;
    .ul {
      margin-right: 0;
      margin-left: 0;
      -webkit-box-align: stretch;
      align-items: stretch;
      display: -webkit-box;
      display: flex;
      flex-wrap: wrap;
      -webkit-box-pack: justify;
      justify-content: space-between;
        
      .li {
        padding: 0 6px;
        margin-bottom: 36px;
        .box {
          .tent {
            margin-top: 6px;
            p {
              margin-top: 12px;
              margin-bottom: 0;
              font-size: 16px;
              line-height: 24px;
            }
            strong {
              font-size: 21px;
              line-height: 30px;
              // color: #333
            }
          }
          img {
            width: 100%;
          }
        }
      }
    }
  }
  #why p {
    font-size: 16px;
    line-height: 24px;
    margin: 35px 0;
    i {
      font-family: 'AudiTypeExtendedNormal'
    }
  }

  #why .blog {
      position: relative;
      background-color: #e5e5e5;
      padding: 10px;
      margin-bottom: 15px;
  }

  #why .blog-title {
      overflow: hidden;
      margin-bottom: 10px;
  }

  #why .blog-title img {
      float: right;
  }

  #why .show-blog {
      position: relative;
      display: block;
      padding-left: 15px;
      width: 80%;
      color: #000;
      font-size: 12pt;
      text-decoration: initial;
      float: left;
  }

  #why .show-blog:before {
      display: block;
      content: "";
      width: 10px;
      height: 10px;
      background-image: url(../images/plus_btn.png);
      position: absolute;
      left: 0;
      top: 5px;
  }

  #why .active .show-blog:before {
      background-position: 0 -10px;
  }

  #why .blog-content {
      // display: none;
  }

  #why a.more,
  #search a.more {
      color: #000;
      text-decoration: underline;
  }
  
  @media (max-width: 767px) {
    /*why*/
    #why .blog-wrapper .row>div {
        padding-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/WhyBuyAudiApproved.vue